var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8294 12.4031C13.8463 11.1999 13.1523 10.5874 13.1523 7.27047C13.1523 4.23294 11.6012 3.15077 10.3246 2.62518C10.155 2.55551 9.99536 2.3955 9.94369 2.22132C9.71975 1.45917 9.09195 0.787735 8.25745 0.787735C7.42294 0.787735 6.79477 1.45955 6.57312 2.22209C6.52145 2.39818 6.36182 2.55551 6.19224 2.62518C4.91406 3.15153 3.36449 4.22988 3.36449 7.27047C3.36257 10.5874 2.66855 11.1999 1.68552 12.4031C1.27822 12.9015 1.63499 13.6498 2.34738 13.6498H14.1713C14.8799 13.6498 15.2344 12.8992 14.8294 12.4031Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7074 13.6499V14.2623C10.7074 14.9121 10.4493 15.5352 9.98982 15.9947C9.53037 16.4541 8.90722 16.7123 8.25746 16.7123C7.6077 16.7123 6.98455 16.4541 6.5251 15.9947C6.06565 15.5352 5.80753 14.9121 5.80753 14.2623V13.6499",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3154 12.6153C13.3324 11.4122 12.6383 10.7997 12.6383 7.48274C12.6383 4.44521 11.0872 3.36303 9.81059 2.83744C9.64101 2.76778 9.48138 2.60776 9.4297 2.43359C9.20576 1.67143 8.57797 1 7.74346 1C6.90896 1 6.28078 1.67182 6.05914 2.43436C6.00746 2.61044 5.84783 2.76778 5.67825 2.83744C4.40008 3.3638 2.8505 4.44215 2.8505 7.48274C2.84859 10.7997 2.15457 11.4122 1.17154 12.6153C0.764238 13.1137 1.12101 13.8621 1.8334 13.8621H13.6574C14.3659 13.8621 14.7204 13.1114 14.3154 12.6153Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1934 13.8621V14.4746C10.1934 15.1244 9.93529 15.7475 9.47584 16.207C9.01639 16.6664 8.39324 16.9245 7.74348 16.9245C7.09372 16.9245 6.47057 16.6664 6.01112 16.207C5.55167 15.7475 5.29355 15.1244 5.29355 14.4746V13.8621",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell_white.b006d0c62063e6db8a0ae83c1a84bc47.svg";
export { ForwardRef as ReactComponent };